module.exports = __webpack_public_path__ + "media/images/related-photo-036e30677289a9a2428a450f94e44158.jpg";